// THOM Verify™ · Environment Classification & Legal Visibility Framework
// Single source of truth on the frontend. Do NOT hard-code environment
// colors, labels or banner copy anywhere else — always resolve via this file.

export const ENVIRONMENTS = {
  demonstration: {
    key: "demonstration",
    label: "Demonstration",
    shortLabel: "Demo",
    icon: "info",
    chipPrefix: "DEMO",
    watermark: "DEMONSTRATION",
    legallyValid: false,
    // Tailwind-safe utility classes (concrete class names, no interpolation).
    accent: "#EA580C",
    bannerClass: "border-orange-500 bg-orange-50 text-orange-900",
    bannerKickerClass: "text-orange-800",
    chipClass: "bg-orange-500 text-white border border-orange-600",
    softChipClass: "bg-orange-100 text-orange-900 border border-orange-300",
    barClass: "bg-orange-500",
    watermarkClass: "border-orange-400/85 text-orange-100 bg-black/45",
    banner:
      "This is Demonstration Content. This asset has NOT been officially verified and has no legal or commercial validity.",
    shortNotice: "Demonstration Content · Not legally valid",
    legalStatus: "Not legally valid — demonstration only",
    hoverText:
      "Demonstration Environment – Evaluation, training and sample data. Not a genuine THOM Verify™ verification.",
  },
  sandbox: {
    key: "sandbox",
    label: "Sandbox",
    shortLabel: "Sandbox",
    icon: "wrench",
    chipPrefix: "SBX",
    watermark: "SANDBOX",
    legallyValid: false,
    accent: "#2563EB",
    bannerClass: "border-blue-500 bg-blue-50 text-blue-900",
    bannerKickerClass: "text-blue-800",
    chipClass: "bg-blue-600 text-white border border-blue-700",
    softChipClass: "bg-blue-100 text-blue-900 border border-blue-300",
    barClass: "bg-blue-600",
    watermarkClass: "border-blue-300/85 text-blue-100 bg-black/45",
    banner:
      "Testing Environment – Data is for system integration and testing only.",
    shortNotice: "Sandbox · Integration testing · No legal effect",
    legalStatus: "Sandbox test environment — no legal effect",
    hoverText:
      "Sandbox Environment – Developer and integration testing. No legal standing.",
  },
  pilot: {
    key: "pilot",
    label: "Pilot",
    shortLabel: "Pilot",
    icon: "rocket",
    chipPrefix: "PLT",
    watermark: "PILOT ENVIRONMENT",
    legallyValid: false,
    accent: "#7C3AED",
    bannerClass: "border-violet-500 bg-violet-50 text-violet-900",
    bannerKickerClass: "text-violet-800",
    chipClass: "bg-violet-600 text-white border border-violet-700",
    softChipClass: "bg-violet-100 text-violet-900 border border-violet-300",
    barClass: "bg-violet-600",
    watermarkClass: "border-violet-300/85 text-violet-100 bg-black/45",
    banner:
      "Pilot Deployment – Subject to operational validation.",
    shortNotice: "Pilot programme · Subject to operational validation",
    legalStatus:
      "Pilot programme — subject to operational validation",
    hoverText:
      "Pilot Environment – Controlled customer pilot or limited production rollout under governance.",
  },
  production: {
    key: "production",
    label: "Production",
    shortLabel: "Live",
    icon: "shield-check",
    chipPrefix: "LIVE",
    watermark: null,
    legallyValid: true,
    accent: "#15803D",
    bannerClass: "",
    bannerKickerClass: "",
    chipClass: "bg-emerald-700 text-white border border-emerald-800",
    softChipClass: "bg-emerald-100 text-emerald-900 border border-emerald-300",
    barClass: "bg-emerald-700",
    watermarkClass: "",
    banner: null,
    shortNotice: "Production Environment – Official THOM Verify™ Live Verification",
    legalStatus: "Legally valid within stated scope",
    hoverText: "Production Environment – Official THOM Verify™ Live Verification.",
  },
};

const ALIAS = {
  demo: "demonstration",
  demonstration: "demonstration",
  sandbox: "sandbox",
  preview: "pilot",
  pilot: "pilot",
  prod: "production",
  production: "production",
  live: "production",
};

export const normaliseEnv = (env) => {
  if (!env) return "production";
  const k = String(env).trim().toLowerCase();
  return ALIAS[k] || "production";
};

/**
 * Resolve the environment for an arbitrary record.
 * Precedence: explicit `environment` field → is_sandbox → is_pilot → is_demo → production.
 */
export const classifyRecord = (record) => {
  if (!record) return "production";
  if (record.environment) return normaliseEnv(record.environment);
  if (record.is_sandbox) return "sandbox";
  if (record.is_pilot) return "pilot";
  if (record.is_demo) return "demonstration";
  return "production";
};

export const envMeta = (env) => ENVIRONMENTS[normaliseEnv(env)];
